@for (field of fields; track field; let i = $index) {
  <app-edit-field-allocations
    [formGroup]="fieldControls.controls[i]"
    [field]="field"
  ></app-edit-field-allocations>
}
